module.exports = __webpack_public_path__ + "static/media/banner-transformador.dcb51789.jpg";